import { Auth } from '../../consumer-app/services/session/types';
const defaultSuccessCallback = '/profile/#/accounts';
export const getCallbackUrl = function () {
    let callbackUrl = sessionStorage.getItem(Auth.AUTH_CALLBACK);
    if (callbackUrl) {
        sessionStorage.removeItem(Auth.AUTH_CALLBACK);
    }
    else {
        callbackUrl = defaultSuccessCallback;
    }
    return callbackUrl;
};
